module.exports = __webpack_public_path__ + "img/Home_AMC-Member_tag.e9198ee3.jpg";